import { useQuery } from '@apollo/client';
import { useNotifications } from '@risksmart-app/components/src/notifications/useNotifications';
import { GetRiskAssessmentResultConfigAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useIsFeatureVisibleToOrg } from 'src/utils/featureFlags';

import { useGetRiskAssessmentResultConfigAuditByIdTRPC } from './useGetRiskAssessmentResultConfigAuditByIdTRPC';

export const useGetRiskAssessmentResultConfigAuditById = (
  id?: string,
  skip?: boolean
) => {
  const trpcEnabled = useIsFeatureVisibleToOrg('trpc');
  const { addNotification } = useNotifications();

  if (!id && !skip) {
    throw new Error(
      'Risk Assessment Result Config ID is required unless skip is true'
    );
  }

  const {
    data: graphqlData,
    loading: graphqlLoading,
    refetch: graphqlRefetch,
  } = useQuery(GetRiskAssessmentResultConfigAuditByIdDocument, {
    variables: {
      id: id!,
    },
    skip: trpcEnabled || skip,
    onError: (error) => {
      if (!trpcEnabled) {
        addNotification({
          type: 'error',
          content: <>{error.message}</>,
        });
      }
    },
  });

  const {
    data: trpcData,
    loading: trpcLoading,
    refetch: trpcRefetch,
  } = useGetRiskAssessmentResultConfigAuditByIdTRPC(id, skip);

  if (trpcEnabled) {
    return {
      data: trpcData,
      loading: trpcLoading,
      refetch: () => trpcRefetch(),
    };
  } else {
    return {
      data: graphqlData,
      loading: graphqlLoading,
      refetch: () => graphqlRefetch(),
    };
  }
};
